import { useState } from "react";
import { PopupMain } from "../popup/PopupMain";

const ClearDataButton = ({ planName, onClear, className = "" }) => {
  const [openPopup, setOpenPopup] = useState(false);

  return (
    <>
      <button
        className={`flex items-center gap-1 text-red-400 hover:text-red-600 text-xs font-medium flex-none ml-auto ${className}`}
        onClick={(e) => {
          e.stopPropagation();
          setOpenPopup(true);
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          className="w-3.5 h-3.5"
        >
          <polyline points="3 6 5 6 21 6" />
          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
        </svg>
        ล้างข้อมูล
      </button>

      <PopupMain
        open={openPopup}
        title={`ล้างข้อมูล${planName}`}
        text={`คุณต้องการล้างข้อมูล${planName}ทั้งหมดใช่หรือไม่? การดำเนินการนี้ไม่สามารถย้อนกลับได้`}
        textButton="ยืนยัน"
        textButton2="ยกเลิก"
        button2
        color="bg-red-500"
        hover="hover:bg-red-600 group"
        onClick={() => {
          onClear();
          setOpenPopup(false);
        }}
        onClickSecond={() => setOpenPopup(false)}
      />
    </>
  );
};

export default ClearDataButton;
